module.exports = __webpack_public_path__ + "static/media/AreYouActiveDutyMilitary.e08c26ef.svg";